import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const HubspotIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M20.53 20.412c-1.55 0-2.806-1.198-2.806-2.676 0-1.479 1.256-2.677 2.805-2.677 1.55 0 2.805 1.198 2.805 2.677 0 1.478-1.256 2.676-2.805 2.676Zm.839-7.83v-2.38c.651-.294 1.107-.923 1.107-1.653v-.055c0-1.007-.863-1.83-1.918-1.83H20.5c-1.055 0-1.919.823-1.919 1.83v.055c0 .73.457 1.359 1.108 1.653v2.38a5.57 5.57 0 0 0-2.586 1.087L10.25 8.583a1.95 1.95 0 0 0 .078-.515c0-1.14-.967-2.066-2.162-2.068C6.972 5.999 6 6.922 6 8.063c-.001 1.14.966 2.066 2.162 2.067a2.22 2.22 0 0 0 1.066-.276l6.739 5.003a5.027 5.027 0 0 0-.91 2.879c0 1.114.37 2.145.993 2.993L14 22.685a1.829 1.829 0 0 0-.507-.08c-.982 0-1.779.76-1.779 1.698 0 .937.797 1.697 1.779 1.697.982 0 1.778-.76 1.778-1.697 0-.17-.034-.33-.082-.485l2.027-1.934a5.613 5.613 0 0 0 3.313 1.072c3.022 0 5.471-2.337 5.471-5.22 0-2.61-2.01-4.767-4.631-5.154Z"
      fill={preserveColor ? "#FF7A59" : undefined}
    />
  </BaseIcon>
);
